import { Icon } from '@chakra-ui/react';

import { dataTableSortIconColor, dataTableSortIconSizePx } from './data-table.kds';

export type DataTableSortDirection = 'asc' | 'desc';

export interface DataTableSortIconProps {
  direction?: DataTableSortDirection;
}

/** Figma arrow-up (node 1050:15785) — 16×16, 1.5px stroke, round caps. */
const sortArrowUpPath = 'M12.6667 8L8 3.33333L3.33333 8M8 3.33333V12.6667';

/** Mirrored arrow-down for descending sort (same spec as arrow-up). */
const sortArrowDownPath = 'M3.33333 8L8 12.6667L12.6667 8M8 12.6667V3.33333';

/** Presentational sort affordance — Figma `Sorted=Yes` only; no icon when unsorted. */
export const DataTableSortIcon = ({ direction }: Readonly<DataTableSortIconProps>) => {
  if (!direction) {
    return null;
  }

  const path = direction === 'desc' ? sortArrowDownPath : sortArrowUpPath;

  return (
    <Icon
      data-testid="data-table-sort-icon"
      boxSize={`${dataTableSortIconSizePx}px`}
      color={dataTableSortIconColor}
      aria-hidden
    >
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d={path} stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </Icon>
  );
};
